import { rankWith, isNumberControl } from '@jsonforms/core';
import type { ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { IntegerControlComponent } from 'src/components/JsonForm/controls/IntegerControl';

export const NumberControlComponent = (props: ControlProps) => {
    return <IntegerControlComponent {...props} />;
};

export const NumberControlTester = rankWith(
    4, //increase rank as needed
    isNumberControl,
);

export const NumberControl = withJsonFormsControlProps(NumberControlComponent);
